/* GTG UX PDP carousel / shipping Clarity P0 — STAGING 2026-09-18 */
(function () {
  var GALLERY = '.product-media-gallery';
  var INIT = 'data-gtg-ux-pdp';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function markShippingNonInteractive() {
    qsa('.free-shipping-icon-cont').forEach(function (el) {
      if (el.getAttribute(INIT) === 'ship') return;
      el.setAttribute(INIT, 'ship');
      el.setAttribute('role', 'note');
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) {
        el.setAttribute('aria-label', text);
        el.setAttribute('title', text);
      }
    });
  }

  function ensureLightbox() {
    var box = qs('#gtg-ux-lightbox');
    if (box) return box;
    box = document.createElement('div');
    box.id = 'gtg-ux-lightbox';
    box.className = 'gtg-ux-lightbox';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product image zoom');
    box.innerHTML =
      '<button type="button" class="gtg-ux-lightbox__close" aria-label="Close zoom">&times;</button>' +
      '<img class="gtg-ux-lightbox__img" alt="" />';
    document.body.appendChild(box);
    var img = qs('.gtg-ux-lightbox__img', box);
    function close() {
      box.hidden = true;
      img.removeAttribute('src');
      document.documentElement.style.overflow = '';
    }
    qs('.gtg-ux-lightbox__close', box).addEventListener('click', close);
    box.addEventListener('click', function (e) {
      if (e.target === box) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) close();
    });
    box._gtgOpen = function (src, alt) {
      img.src = src;
      img.alt = alt || '';
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      qs('.gtg-ux-lightbox__close', box).focus();
    };
    box._gtgClose = close;
    return box;
  }

  function openZoom(src, alt) {
    if (!src) return;
    ensureLightbox()._gtgOpen(src, alt);
  }

  function enhanceArrows(gallery) {
    qsa('.slick-arrow', gallery).forEach(function (btn) {
      if (btn.tagName && btn.tagName.toLowerCase() === 'button') {
        btn.type = 'button';
      }
      var isPrev = btn.classList.contains('slick-prev');
      var isNext = btn.classList.contains('slick-next');
      if (isPrev) {
        btn.setAttribute('aria-label', 'Previous product image');
      } else if (isNext) {
        btn.setAttribute('aria-label', 'Next product image');
      }
      btn.setAttribute('role', 'button');
    });
  }

  function enableMainArrows(gallery) {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;
    var $main = jQuery(gallery).find('.slider-main');
    if (!$main.length || !$main.hasClass('slick-initialized')) return;
    try {
      $main.slick('slickSetOption', 'arrows', true, true);
    } catch (e) {}
  }

  function wireZoom(gallery) {
    if (gallery.getAttribute(INIT) === 'zoom') return;
    gallery.setAttribute(INIT, 'zoom');

    qsa('.slider-main .slick-slide, .slider-main .slider-nav-item', gallery).forEach(function (slide) {
      var img = qs('img', slide);
      if (!img) return;
      if (!qs('.gtg-ux-zoom-btn', slide)) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gtg-ux-zoom-btn';
        btn.setAttribute('aria-label', 'Zoom product image');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openZoom(img.currentSrc || img.src, img.alt);
        });
        slide.appendChild(btn);
      }
      img.addEventListener('click', function (e) {
        e.preventDefault();
        openZoom(img.currentSrc || img.src, img.alt);
      });
    });
  }

  function enhanceGallery(gallery) {
    enableMainArrows(gallery);
    enhanceArrows(gallery);
    wireZoom(gallery);
    /* Allow vertical page scroll; Slick swipe was eating first gesture on PDP */
    Array.prototype.forEach.call(gallery.querySelectorAll('.slick-list, .slick-track'), function (el) {
      el.style.touchAction = 'pan-y pinch-zoom';
      el.setAttribute('data-gtgAllowVerticalScroll', '1');
    });
    gallery.setAttribute('data-gtgAllowVerticalScroll', '1');
  }

  function boot() {
    markShippingNonInteractive();
    qsa(GALLERY).forEach(enhanceGallery);
  }

  function bootWhenReady() {
    boot();
    var n = 0;
    var t = setInterval(function () {
      n += 1;
      boot();
      if (n >= 20) clearInterval(t);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWhenReady);
  } else {
    bootWhenReady();
  }
  document.addEventListener('shopify:section:load', boot);
})();
